import { render, staticRenderFns } from "./DashboardProveedores.vue?vue&type=template&id=f76a292a&scoped=true&lang=pug"
import script from "./DashboardProveedores.vue?vue&type=script&lang=js"
export * from "./DashboardProveedores.vue?vue&type=script&lang=js"
import style0 from "./DashboardProveedores.vue?vue&type=style&index=0&id=f76a292a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76a292a",
  null
  
)

export default component.exports